<template>
  <nav class="navbar is-spaced">
    <div class="navbar-brand">
      <router-link id="topnav-logo-home" to="/" class="navbar-item">
        <img src="@/assets/img/logo-color.svg" alt="SalarySeed logo" width="200">
      </router-link>
  
      <a role="button" class="navbar-burger" :class="{'is-active': navbarExpanded}" aria-label="menu" :aria-expanded="navbarExpanded" @click="toggleNavbar">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="page-navbar" class="navbar-menu" :class="{'is-active': navbarExpanded}">
      <div class="navbar-start is-justify-content-center is-flex-grow-1">
        <router-link to="/" id="topnav-home" class="navbar-item" active-class="is-active">
          Home
        </router-link>

        <router-link to="/how-it-works" id="topnav-how-it-works" class="navbar-item" active-class="is-active">
          How it works
        </router-link>
        
        <router-link to="/about" id="topnav-about" class="navbar-item" active-class="is-active">
          Our mission
        </router-link>

        <router-link to="/contact" id="topnav-contact" class="navbar-item" active-class="is-active">
          Contact
        </router-link>
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <router-link to="/register" id="topnav-cta" class="button is-primary">
              Start saving
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<style lang="scss" scoped>
  @media screen and (min-width: 1024px) {
    .navbar-link.is-active, a.navbar-item.is-active {
      color: $primary;
    }
  }
</style>

<script>
  export default {
    data() {
      return {
        navbarExpanded: false
      }
    },

    methods: {
      toggleNavbar() {
        this.navbarExpanded = !this.navbarExpanded;
      }
    },

    watch: {
      $route() {
        this.navbarExpanded = false;
      }
    }
  }
</script>
